// extracted by mini-css-extract-plugin
export default {"container":"auth_container__TloQ6","title":"auth_title__i19Id","button":"auth_button__Ox6w3","link":"auth_link__9p+S9"};